const getKey = (keyName, id) => (
  id !== void 0 ? `${keyName}[${id}]` : keyName
)

class PathStorage {
  /** @param {string} keyName */
  constructor(keyName, prefix = '') {
    this.keyName = prefix ? `${prefix}-${keyName}` : keyName
  }

  /**
   * @template T
   * @return { T | null }
   */
  get(id, defaults) {
    const keyName = getKey(this.keyName, id)

    const str = localStorage.getItem(keyName)

    if (defaults !== void 0 && str === null) return defaults
    if (!str) return str

    try {
      return JSON.parse(str)
    } catch {
      return str
    }
  }

  set(data, id) {
    const keyName = getKey(this.keyName, id)

    if (typeof data === 'object') {
      const json = JSON.stringify(data)
      localStorage.setItem(keyName, json)
    } else {
      localStorage.setItem(keyName, data)
    }

    return this
  }

  remove(id) {
    const keyName = getKey(this.keyName, id)
    localStorage.removeItem(keyName)
    return this
  }

  clear() {
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i)
      if (key.includes(this.keyName)) {
        localStorage.removeItem(key)
      }
    }
  }
}

const prefix = process.env.NODE_ENV
const name = process.env.VUE_APP_NAME

export const StorageService = {
  profile: new PathStorage('profile', `${name}-${prefix}`),
  formDataDraft: new PathStorage('form-data-draft', `${name}-${prefix}`),
  lkNewsButton: new PathStorage('lk-news-button', `${name}-${prefix}`),
}
